/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const ItemType = {
  Membership: "MEMBERSHIP",
  PaidClass: "PAID_CLASS",
  Donation: "DONATION",
  DamageWaiver: "DAMAGE_WAIVER",
  GuestPrivs: "GUEST_PRIVS",
  Product: "PRODUCT",
  Card: "CARD",
  GiftCard: "GIFT_CARD",
} as const;

export type ItemType = (typeof ItemType)[keyof typeof ItemType];

export type ItemTypeEnumType = typeof ItemType;
export type ItemTypeOptional = ItemType;
export type ItemTypeTrackedI = ItemType;
export type ItemTypeTracked = ItemType;
export type ItemTypeMetaI = EnumMetaType<ItemTypeEnumType, ItemType>;
export const ItemTypeMeta = typeMetaEnum<ItemTypeEnumType, ItemType>(
  "ItemType",
  ItemType,
);
export function transformDatesItemType(model: ItemType) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
